import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Box, Button, LazyImage, Text } from '@miro-site/core';
import React, { useEffect, useRef } from 'react';
import { Transition } from 'react-transition-group';
import { useTheme } from 'styled-components';
import useFullscreenModal from '../../../hooks/useFullscreenModal';
import TransparentButton from '../../button/TransparentButton';
import Popup from '../../popup/Popup';
import { CardTags } from './CardTags';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var transitionStyles = {
  entering: {
    opacity: 1,
    visibility: 'visible'
  },
  entered: {
    opacity: 1,
    visibility: 'visible'
  },
  exiting: {
    opacity: 0,
    visibility: 'visible'
  },
  exited: {
    opacity: 0,
    visibility: 'hidden'
  }
};
var defaultStyle = {
  transition: "opacity 250ms ease-in-out, visibility 250ms ease-in-out",
  opacity: 0,
  visibility: 'hidden',
  zIndex: 100
};

var CardDescription = function CardDescription(_ref) {
  var _ref$isShown = _ref.isShown,
      isShown = _ref$isShown === void 0 ? false : _ref$isShown,
      onClose = _ref.onClose,
      templateActions = _ref.templateActions,
      isFullscreen = _ref.isFullscreen,
      metadataId = _ref.metadataId,
      templatePagePath = _ref.templatePagePath,
      previewButton = _ref.previewButton,
      actionButtonProps = _ref.actionButtonProps,
      thumbnail = _ref.thumbnail,
      title = _ref.title,
      description = _ref.description,
      popupStyles = _ref.popupStyles,
      headingStyles = _ref.headingStyles,
      descriptionStyles = _ref.descriptionStyles,
      tags = _ref.tags;
  if (isFullscreen) useFullscreenModal(isShown);

  var defaultPreviewButton = /*#__PURE__*/_jsx(TransparentButton, {
    $size: "medium",
    href: templatePagePath,
    children: templateActions.PREVIEW
  });

  var popupRef = useRef(null);

  var handleOutsideClick = function handleOutsideClick(e) {
    var clickOutsideNav = popupRef.current && !popupRef.current.contains(e.target);

    if (clickOutsideNav && onClose) {
      onClose();
    }
  };

  useEffect(function () {
    if (!isShown) {
      return;
    }

    document.addEventListener('click', handleOutsideClick, true);
    return function () {
      document.removeEventListener('click', handleOutsideClick, true);
    };
  }, [isShown]);
  var theme = useTheme();
  return /*#__PURE__*/_jsx(Transition, {
    "in": isShown,
    timeout: 250,
    children: function children(state) {
      return /*#__PURE__*/_jsx(Popup, {
        ref: popupRef,
        "data-track-place": "card-description",
        onCloseClick: onClose,
        $styles: _objectSpread(_objectSpread(_objectSpread({}, defaultStyle), popupStyles), transitionStyles[state]),
        onMouseLeave: function onMouseLeave(e) {
          return onClose && onClose();
        },
        children: /*#__PURE__*/_jsxs(Box, {
          children: [isFullscreen && /*#__PURE__*/_jsxs(_Fragment, {
            children: [thumbnail && /*#__PURE__*/_jsx(Box, {
              $mb: [20, null, null, null],
              $styles: {
                position: 'relative',
                overflow: 'hidden',
                height: 0,
                paddingTop: ['64.307%', null, null, null]
              },
              children: /*#__PURE__*/_jsx(LazyImage, _objectSpread(_objectSpread({}, thumbnail), {}, {
                detectIntersection: false
              }))
            }), /*#__PURE__*/_jsxs(Box, {
              $mb: [28, null, null, null],
              $styles: {
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                flexFlow: 'row wrap',
                height: '100%'
              },
              children: [actionButtonProps ? /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
                "data-track-id": "use-template",
                "data-template-id": metadataId,
                $mr: [14, null],
                $mb: [12, null],
                $buttonType: "primary",
                $size: "medium",
                onClick: actionButtonProps.onClick
              }, actionButtonProps), {}, {
                children: actionButtonProps.children || templateActions.USE_TEMPLATE
              })) : null, previewButton ? previewButton(defaultPreviewButton) : defaultPreviewButton]
            })]
          }), /*#__PURE__*/_jsx(Text, {
            as: "h4",
            $color: "primaryIndigo",
            $pr: isFullscreen ? 0 : 48,
            $mb: [24, 12, 12, 12],
            $styles: _objectSpread({
              fontWeight: 700,
              fontSize: [24, 16, 16, 16],
              lineHeight: [32, 24, 24, 24]
            }, headingStyles),
            children: title
          }), /*#__PURE__*/_jsx(CardTags, {
            descriptionStyles: descriptionStyles,
            headingStyles: headingStyles,
            tags: tags
          }), /*#__PURE__*/_jsx(Text, {
            $variant: ['p1', 'p2', 'p2', 'p2'],
            $styles: _objectSpread({
              color: theme.templates.colors.secondary60
            }, descriptionStyles),
            children: description
          })]
        })
      });
    }
  });
};

export default CardDescription;